import {
  LIBRARY_SALES_TYPE_HUB_PAGE_REQUEST,
  LIBRARY_SALES_TYPE_HUB_SET_LIST_SALES,
  LIBRARY_SALES_TYPE_HUB_SET_META_SALES_TYPE,
  LIBRARY_SALES_TYPE_HUB_SET_SALES_DETAIL,
  LIBRARY_SALES_TYPE_HUB_OPEN_RIGHT_COLUMN,
  LIBRARY_SALES_TYPE_HUB_CLOSE_RIGHT_COLUMN,
  LIBRARY_SALES_TYPE_HUB_ON_CLICK_CREATE_SALES,
  LIBRARY_SALES_TYPE_HUB_SET_STATUS_GRATUITY,
  LIBRARY_SALES_TYPE_HUB_ON_CLICK_CANCEL,
  LIBRARY_SALES_TYPE_HUB_SET_GRATUITY,
  LIBRARY_SALES_TYPE_HUB_SUBMIT_FORM_CREATE,
  LIBRARY_SALES_TYPE_HUB_SUBMIT_FORM_UPDATE,
  LIBRARY_SALES_TYPE_HUB_IS_SUBMITTING_FORM,
  LIBRARY_SALES_TYPE_HUB_SHOW_NO_GRATUITY_MODAL,
  LIBRARY_SALES_TYPE_HUB_HIDE_NO_GRATUITY_MODAL,
  LIBRARY_SALES_TYPE_HUB_ON_CLICK_ROW,
  LIBRARY_SALES_TYPE_HUB_DELETE_SALES_REQUEST,
  LIBRARY_SALES_TYPE_HUB_SET_DELETED_SALES,
  LIBRARY_SALES_TYPE_HUB_SHOW_DELETE_MODAL,
  LIBRARY_SALES_TYPE_HUB_HIDE_DELETE_MODAL,
  LIBRARY_SALES_TYPE_HUB_SHOW_CHECK_DELETABLE_MODAL,
  LIBRARY_SALES_TYPE_HUB_DELETE_SALES,
  LIBRARY_SALES_TYPE_HUB_SALES_TYPE_REQUEST,
  LIBRARY_SALES_TYPE_HUB_SET_CHANNEL_ASYNC_JOB,
  LIBRARY_SALES_TYPE_HUB_HANDLE_SUCCESS_ASYNC_JOB,
  LIBRARY_SALES_TYPE_HUB_HANDLE_FAILED_ASYNC_JOB,
} from './constants';

export function pageRequest() {
  return { type: LIBRARY_SALES_TYPE_HUB_PAGE_REQUEST };
}

export function setListSalesType(salesType) {
  return {
    type: LIBRARY_SALES_TYPE_HUB_SET_LIST_SALES,
    payload: { salesType },
  };
}

export function setMetaSalesType(metaSalesType) {
  return {
    type: LIBRARY_SALES_TYPE_HUB_SET_META_SALES_TYPE,
    payload: { meta: metaSalesType },
  };
}

export function setSalesTypeDetail(salesTypeDetail) {
  return {
    type: LIBRARY_SALES_TYPE_HUB_SET_SALES_DETAIL,
    payload: { salesTypeDetail },
  };
}

export function openRightColumn() {
  return { type: LIBRARY_SALES_TYPE_HUB_OPEN_RIGHT_COLUMN };
}

export function closeRightColumn() {
  return { type: LIBRARY_SALES_TYPE_HUB_CLOSE_RIGHT_COLUMN };
}

export function onClickCreateSalesType() {
  return { type: LIBRARY_SALES_TYPE_HUB_ON_CLICK_CREATE_SALES };
}

export function setGratuityStatusFromSetting(enableGratuity) {
  return {
    type: LIBRARY_SALES_TYPE_HUB_SET_STATUS_GRATUITY,
    payload: { enableGratuity },
  };
}

export function onClickCancel() {
  return { type: LIBRARY_SALES_TYPE_HUB_ON_CLICK_CANCEL };
}

export function setGratuity(gratuity) {
  return { type: LIBRARY_SALES_TYPE_HUB_SET_GRATUITY, payload: { gratuity } };
}

export function submitFormCreate(data, previousSalesType) {
  return {
    type: LIBRARY_SALES_TYPE_HUB_SUBMIT_FORM_CREATE,
    payload: { data, previousSalesType },
  };
}

export function submitFormUpdate(values, currentSalesType, gratuity) {
  return {
    type: LIBRARY_SALES_TYPE_HUB_SUBMIT_FORM_UPDATE,
    payload: {
      values,
      currentSalesType,
      gratuity,
    },
  };
}

export function isSubmittingForm(isSubmittingFormPayload) {
  return {
    type: LIBRARY_SALES_TYPE_HUB_IS_SUBMITTING_FORM,
    payload: { isSubmittingForm: isSubmittingFormPayload },
  };
}

export function showNoGratuityModal() {
  return { type: LIBRARY_SALES_TYPE_HUB_SHOW_NO_GRATUITY_MODAL };
}

export function hideNoGratuityModal() {
  return { type: LIBRARY_SALES_TYPE_HUB_HIDE_NO_GRATUITY_MODAL };
}

export function onClickRow(salesType) {
  return { type: LIBRARY_SALES_TYPE_HUB_ON_CLICK_ROW, payload: { salesType } };
}

export function deleteSalesTypeRequest(deletedSalesType) {
  return {
    type: LIBRARY_SALES_TYPE_HUB_DELETE_SALES_REQUEST,
    payload: { deletedSalesType },
  };
}

export function setDeletedSalesType(deletedSalesType) {
  return {
    type: LIBRARY_SALES_TYPE_HUB_SET_DELETED_SALES,
    payload: { deletedSalesType },
  };
}

export function showDeleteModal() {
  return { type: LIBRARY_SALES_TYPE_HUB_SHOW_DELETE_MODAL };
}

export function hideDeleteModal() {
  return { type: LIBRARY_SALES_TYPE_HUB_HIDE_DELETE_MODAL };
}

export function showSalesTypeDeletableModal(id, showCheckDeletableModal, type) {
  return {
    type: LIBRARY_SALES_TYPE_HUB_SHOW_CHECK_DELETABLE_MODAL,
    payload: { showCheckDeletableModal, type },
  };
}

export function deleteSalesType(deletedSalesType, previousSales) {
  return {
    type: LIBRARY_SALES_TYPE_HUB_DELETE_SALES,
    payload: { deletedSalesType, previousSales },
  };
}

export function salesTypeRequest(params, previousSalesType) {
  return {
    type: LIBRARY_SALES_TYPE_HUB_SALES_TYPE_REQUEST,
    payload: { params, previousSalesType },
  };
}

export function setEventAsyncJob(channelName) {
  return {
    type: LIBRARY_SALES_TYPE_HUB_SET_CHANNEL_ASYNC_JOB,
    payload: { channelName },
  };
}

export function handleSuccessAsyncJob(resourceId) {
  return {
    type: LIBRARY_SALES_TYPE_HUB_HANDLE_SUCCESS_ASYNC_JOB,
    payload: { resourceId },
  };
}

export function handleFailedAsyncJob(errorMessage) {
  return {
    type: LIBRARY_SALES_TYPE_HUB_HANDLE_FAILED_ASYNC_JOB,
    payload: { errorMessage },
  };
}
